import ViewCad from "../../../config/view";
import { ProcedimentoViewProps } from "../procedimento.controller";
import { Procedimento } from "../procedimento.model";

interface ProcedimentoCadastroProps extends ProcedimentoViewProps {
    handleCloseView: () => any
}

export function ProcedimentoCadastro(props: ProcedimentoCadastroProps) {
    const { procedimentoActions,procedimentoState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = procedimentoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = procedimentoActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Procedimento) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Procedimento) => {
        const errors: any = {}
        if (!values.descricao)
            errors.descricao = "Informe descrição do procedimento"
        return errors
    }

    const handleUpdate = (value: Procedimento) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro de procedimento",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo procedimento",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "descricao", label: "Procedimento", type: "text", key: "descricao", colunsXS: 12, colunsSM: 12, colunsMD: 12, require: true },
        ],
    })

    return viewCad
}



